import React from 'react';
import Carousel from '../Components/Carousel';
import AboutSection from '../Components/About';
import PartnersSection from '../Components/Partners';
import Footer from '../Components/Footer';

export default function HomePage() {
  return (
    <div className="font-sans bg-gray-50 text-gray-800">
      <div><Carousel/></div>
      <div><AboutSection/></div>
      <div><PartnersSection/></div>
      {/* Contact Footer
      <footer id="contact" className="bg-gray-800 text-white py-10">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h4 className="text-2xl font-semibold mb-4">Get in Touch</h4>
          <p>Email: contact@mobiledistco.com | Phone: +1 (123) 456-7890</p>
          <p className="mt-4 text-gray-400">&copy; 2025 Mobile Distributors Co. All rights reserved.</p>
        </div>
      </footer> */}
    </div>
  );
}
